var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 19" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M17.7 1.4c1.1.9 1.3 2.7.3 3.9l-.2.2-9.3 9.3-4.2-4.2 9.3-9.3c1.1-1.1 2.8-1.1 4-.1 0 .1.1.1.1.2zM.4 18.6l6.8-2.3-4.6-4.5z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Edit.svg